export default __webpack_public_path__ + "static/media/Varied Pop 3.3f1f5f71.mp3";